import { TStoreState } from 'redux/types';
import { TClientAccessScope } from 'services/api/paymentMethods/types';
import { PAYMENT_METHODS_BLOCKED_TEXT, PAYMENTS_BLOCKED_TEXT } from './constants';
import { TPaymentMethodsStore } from './types';

// ==========================================:
const getPaymentMethodsState = (state: TStoreState): TPaymentMethodsStore => state.paymentMethods;

export const getPaymentMethodsList = (state: TStoreState) => getPaymentMethodsState(state).list;
export const getPaymentMethodsListLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).listLoading;

export const getPaymentMethodsSummary = (state: TStoreState) =>
	getPaymentMethodsState(state).summary;
export const getPaymentMethodsSummaryMerchantId = (state: TStoreState) =>
	getPaymentMethodsState(state).summaryMerchantId;
export const getPaymentMethodsSummaryLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).summaryLoading;

export const getPaymentServices = (state: TStoreState) => getPaymentMethodsState(state).services;
export const getPaymentServicesLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).servicesLoading;

export const getPaymentMethodActionLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).methodActionLoading;
export const getUpdateMethodServicesLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).updateServicesLoading;
export const getUpdateMethodServicesError = (state: TStoreState) =>
	getPaymentMethodsState(state).updateServicesError;

export const getPaymentMethodSetup = (state: TStoreState) => getPaymentMethodsState(state).setup;
export const getPaymentMethodSetupLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).setupLoading;
export const getPaymentMethodSetupError = (state: TStoreState) =>
	getPaymentMethodsState(state).setupError;
export const getPaymentMethodSetupCompleting = (state: TStoreState) =>
	getPaymentMethodsState(state).setupCompleting;
export const getPaymentMethodSetupResult = (state: TStoreState) =>
	getPaymentMethodsState(state).setupResult;

export const getDirectDebitBanks = (state: TStoreState) => getPaymentMethodsState(state).banks;
export const getDirectDebitBanksLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).banksLoading;
export const getDirectDebitCreate = (state: TStoreState) => getPaymentMethodsState(state).ddCreate;
export const getDirectDebitCreateLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).ddCreateLoading;
export const getDirectDebitVerifyLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).ddVerifyLoading;
export const getDirectDebitVerifyResult = (state: TStoreState) =>
	getPaymentMethodsState(state).ddVerifyResult;

// ---------- operator restrictions (client access) ----------

export const getClientAccess = (state: TStoreState) => getPaymentMethodsState(state).clientAccess;
export const getClientAccessLoading = (state: TStoreState) =>
	getPaymentMethodsState(state).clientAccessLoading;
/** A request for the access state has finished (it may have failed: then nothing is blocked). */
export const getClientAccessChecked = (state: TStoreState) =>
	getPaymentMethodsState(state).clientAccessChecked;

// blocked only on an explicit enabled=false: unknown state (not loaded, request failed) blocks nothing
const blockedMessage = (
	scope: TClientAccessScope | null | undefined,
	fallback: string,
): string | null => {
	if (scope?.enabled !== false) return null;
	const message = typeof scope.message === 'string' ? scope.message.trim() : '';
	return message || fallback;
};

/** The operator's message while adding/changing/deleting payment methods is blocked; `null` when allowed. */
export const getPaymentMethodsBlockedMessage = (state: TStoreState): string | null =>
	blockedMessage(getClientAccess(state)?.paymentMethods, PAYMENT_METHODS_BLOCKED_TEXT);

/** The operator's message while Make payment is blocked; `null` when allowed. */
export const getPaymentsBlockedMessage = (state: TStoreState): string | null =>
	blockedMessage(getClientAccess(state)?.payments, PAYMENTS_BLOCKED_TEXT);
